import React from "react"
import { retrieveItemImageFromHero } from "../utilities"
import DfbImage from "../ui-kit/dfb_image"
import CEpaperCard from "../elements/c_epaper_card"
import DfbCard from "../elements/dfb_card"
import DfbHeadline from "../ui-kit/dfb_headline"
import { Transformation } from "cloudinary-react"
import DfbButton from "../ui-kit/dfb_button"
import Section from "./section"

const MHighlightCarousel = (props) => {
  let collection = props.data.collection
  if (props.data.find_item_image) {
    collection = retrieveItemImageFromHero(collection)
  }

  return (
    <Section
      baseClass="m-HighlightCarousel"
      defaultPadding="large"
      data={props.data}
    >
      <div className="m-HighlightCarousel-wrapper">
        <div className="m-HighlightCarousel-container">
          <DfbHeadline
            headline={props.data.headline}
            headline_level="h3"
            add_class="m-HighlightCarousel-headline"
          />
          <div
            className="dfb-Slider m-HighlightCarousel-slider"
            data-transition="slide"
            data-dark
            data-indicators
            data-drag
            data-controls
            role="region"
            tabIndex={0}
          >
            <div className="dfb-Slider-slider">
              <ul className="dfb-Slider-slides">
                {collection.map((item) => (
                  <li key={item.name} className="dfb-Slider-slideItem">
                    <div className="c-CardImage">
                      {item.type === "epaper" && (
                        <CEpaperCard
                          data={Object.assign(item, {
                            hide_image: true,
                            add_class: "c-CardImage-card",
                          })}
                        />
                      )}
                      {item.type !== "epaper" && (
                        <DfbCard
                          data={Object.assign(item, {
                            hide_image: true,
                            add_class: "c-CardImage-card",
                          })}
                        />
                      )}
                      <DfbImage
                        image={
                          typeof item.content.titleimage === "string" &&
                          item.content.titleimage !== ""
                            ? { src: item.content.titleimage }
                            : item.content.titleimage
                        }
                        aspect_ratio="4:3"
                        add_class="c-CardImage-image"
                      >
                        <Transformation
                          crop="fill"
                          gravity="faces:center"
                          width="800"
                          height="600"
                          quality="auto"
                          fetchFormat="auto"
                        />
                      </DfbImage>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
            <ul className="dfb-Slider-controls">
              <li className="dfb-Slider-controlElement dfb-Slider-controlElement--previous">
                <DfbButton
                  icon_type="Dropdown Left"
                  type="submit"
                  add_class="dfb-Slider-control dfb-Slider-control--previous u-Theme-dark"
                  aria-label="previous"
                />
              </li>
              <li className="dfb-Slider-controlElement dfb-Slider-controlElement--next">
                <DfbButton
                  icon_type="Dropdown Right"
                  type="submit"
                  add_class="dfb-Slider-control dfb-Slider-control--next u-Theme-dark"
                  aria-label="next"
                />
              </li>
            </ul>

            <div className="dfb-Indicators dfb-Indicators--secondary dfb-Slider-navContainer u-Theme-dark">
              {collection.map((item, index) => (
                <button
                  key={`m_highlight_carousel_indicator_${props.data.uid}_${index}`}
                  className={
                    "dfb-Indicators-item" + (index === 0 ? " is-active" : "")
                  }
                  data-indicatoritem={index}
                >
                  <span className="dfb-Indicators-itemInner"></span>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="dfb-Pitch dfb-Pitch--middleCircleLeftTop m-HighlightCarousel-playground"></div>
    </Section>
  )
}

export default MHighlightCarousel
